import {
  REMOTE_AUTH_GET,
  REMOTE_AUTH_GET_SUCCESS,
  REMOTE_AUTH_GET_FAILURE,
  REMOTE_AUTH_CHANGE,
  REMOTE_AUTH_CHANGE_SUCCESS,
  REMOTE_AUTH_CHANGE_FAILURE,
  OAUTH_20_GET,
  OAUTH_20_GET_SUCCESS,
  OAUTH_20_GET_FAILURE,
  OAUTH_20_CHANGE,
  OAUTH_20_CHANGE_SUCCESS,
  OAUTH_20_CHANGE_FAILURE,
} from '../actions/apiAuth';

const initialState = {
  remoteAuth: null,
  isRemoteAuthLoading: false,
  isRemoteAuthLoaded: false,
  isRemoteAuthChanging: false,
  remoteAuthChangingErrors: null,
  oauth2ClientId: null,
  oauth2ClientSecret: null,
  isOauth2CredentialsLoading: false,
  isOauth2CredentialsLoaded: false,
  isOauth2CredentialsChanging: false,
  oauth2CredentialsChangingErrors: null,
};

export default function apiAuth(state = initialState, action = {}) {
  switch (action.type) {
    case REMOTE_AUTH_GET:
      return {
        ...state,
        isRemoteAuthLoading: true,
      };

    case REMOTE_AUTH_GET_SUCCESS:
      return {
        ...state,
        remoteAuth: action.response.remote_auth,
        isRemoteAuthLoading: false,
        isRemoteAuthLoaded: true,
      };

    case REMOTE_AUTH_GET_FAILURE:
      return {
        ...state,
        isRemoteAuthLoading: false,
        isRemoteAuthLoaded: false,
      };

    case REMOTE_AUTH_CHANGE:
      return {
        ...state,
        isRemoteAuthChanging: true,
        remoteAuthChangingErrors: null,
      };

    case REMOTE_AUTH_CHANGE_SUCCESS:
      return {
        ...state,
        remoteAuth: action.response.remote_auth,
        isRemoteAuthChanging: false,
        remoteAuthChangingErrors: null,
      };

    case REMOTE_AUTH_CHANGE_FAILURE:
      return {
        ...state,
        isRemoteAuthChanging: false,
        remoteAuthChangingErrors: action.response.errors,
      };

    case OAUTH_20_GET:
      return {
        ...state,
        isOauth2CredentialsLoading: true,
      };

    case OAUTH_20_GET_SUCCESS: {
      const { client_id, client_secret } = action.response.oauth_client;

      return {
        ...state,
        oauth2ClientId: client_id,
        oauth2ClientSecret: client_secret,
        isOauth2CredentialsLoading: false,
        isOauth2CredentialsLoaded: true,
      };
    }

    case OAUTH_20_GET_FAILURE:
      return {
        ...state,
        isOauth2CredentialsLoading: false,
        isOauth2CredentialsLoaded: false,
      };

    case OAUTH_20_CHANGE:
      return {
        ...state,
        isOauth2CredentialsChanging: true,
        oauth2CredentialsChangingErrors: null,
      };

    case OAUTH_20_CHANGE_SUCCESS: {
      const { client_id, client_secret } = action.response.oauth_client;

      return {
        ...state,
        oauth2ClientId: client_id,
        oauth2ClientSecret: client_secret,
        isOauth2CredentialsChanging: false,
        oauth2CredentialsChangingErrors: null,
      };
    }

    case OAUTH_20_CHANGE_FAILURE:
      return {
        ...state,
        isOauth2CredentialsChanging: false,
        oauth2CredentialsChangingErrors: action.response.errors,
      };

    default:
      return state;
  }
}
